import type { AISmartButtonAPIState } from './states';

export const reducer = (pluginState: AISmartButtonAPIState): AISmartButtonAPIState => {
	return pluginState;
};
